export const heroFeatured = {
  title: "晨雾高原湖泊 · 4K 航拍纪实",
  subtitle: "本周编辑精选",
  desc: "跟随镜头穿过清晨的高原薄雾，记录湖面从灰蓝到金橙的完整变色过程。全片 12 分钟，支持分段观看与收藏。",
  meta: "视频 · 12:40 · 4K 画质",
  cover:
    "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20misty%20plateau%20lake%20at%20dawn%20with%20golden%20sunlight%20breaking%20through%20low%20clouds%2C%20warm%20amber%20and%20teal%20tones%2C%20atmospheric%20documentary%20photography%2C%20high%20detail%2C%20editorial%20composition&width=1200&height=800&seq=sh-hero-main&orientation=landscape",
};

export const heroSideCards = [
  {
    title: "城市夜色延时合辑",
    tag: "视频",
    meta: "08:15",
    cover:
      "https://readdy.ai/api/search-image?query=night%20city%20skyline%20time%20lapse%20with%20warm%20street%20lights%20and%20moving%20car%20trails%2C%20amber%20and%20deep%20orange%20color%20palette%2C%20cinematic%20urban%20photography%2C%20clean%20modern%20aesthetic&width=600&height=600&seq=sh-hero-side1&orientation=squarish",
  },
  {
    title: "初夏海岸人像写真",
    tag: "写真",
    meta: "42 张",
    cover:
      "https://readdy.ai/api/search-image?query=tasteful%20portrait%20photography%20of%20a%20woman%20in%20a%20linen%20dress%20standing%20by%20the%20summer%20seaside%2C%20soft%20natural%20light%2C%20warm%20beige%20and%20terracotta%20tones%2C%20elegant%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=sh-hero-side2&orientation=squarish",
  },
  {
    title: "复古胶片色彩图集",
    tag: "图片",
    meta: "120 张",
    cover:
      "https://readdy.ai/api/search-image?query=collection%20of%20vintage%20film%20photographs%20with%20grainy%20warm%20sepia%20tone%2C%20still%20life%20and%20street%20scenes%2C%20muted%20cream%20and%20rust%20colors%2C%20nostalgic%20analog%20aesthetic%2C%20editorial%20grid&width=600&height=600&seq=sh-hero-side3&orientation=squarish",
  },
];

export const trendingVideos = [
  {
    id: "v1",
    title: "戈壁星空下的银河延时",
    category: "自然风光",
    duration: "09:22",
    views: "12.4 万",
    desc: "连续三晚拍摄的沙漠银河轨迹，附带拍摄参数与后期调色思路。",
    cover:
      "https://readdy.ai/api/search-image?query=astrophotography%20time%20lapse%20of%20the%20milky%20way%20above%20a%20desert%20dune%2C%20deep%20night%20sky%20with%20warm%20horizon%20glow%2C%20cinematic%20composition%2C%20high%20detail%2C%20moody%20color%20grade&width=800&height=600&seq=sh-video-01&orientation=landscape",
  },
  {
    id: "v2",
    title: "老巷清晨的人文记录",
    category: "人文纪实",
    duration: "14:05",
    views: "8.7 万",
    desc: "走进即将改造的老城小巷，记录早点摊、修鞋匠与晨练的日常。",
    cover:
      "https://readdy.ai/api/search-image?query=documentary%20shot%20of%20a%20quiet%20old%20alley%20in%20early%20morning%20with%20steam%20from%20a%20breakfast%20stall%2C%20warm%20amber%20light%2C%20observational%20photography%2C%20rich%20texture%2C%20editorial%20style&width=800&height=600&seq=sh-video-02&orientation=landscape",
  },
  {
    id: "v3",
    title: "手冲咖啡的完整流程",
    category: "生活美学",
    duration: "06:48",
    views: "15.1 万",
    desc: "从称豆、研磨到注水节奏，一步步演示一杯手冲的完整细节。",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20pour%20over%20coffee%20brewing%20with%20steam%20and%20warm%20wooden%20table%2C%20soft%20window%20light%2C%20amber%20and%20cream%20tones%2C%20product%20style%20photography%2C%20high%20detail&width=800&height=600&seq=sh-video-03&orientation=landscape",
  },
  {
    id: "v4",
    title: "雨天山城的街头漫游",
    category: "城市影像",
    duration: "11:30",
    views: "6.3 万",
    desc: "雨后的坡道与轻轨，记录山城独有的立体交通与市井烟火。",
    cover:
      "https://readdy.ai/api/search-image?query=rainy%20mountain%20city%20street%20with%20wet%20reflective%20pavement%20and%20an%20elevated%20train%2C%20neon%20free%20warm%20amber%20lamps%2C%20cinematic%20urban%20photography%2C%20atmospheric%20depth&width=800&height=600&seq=sh-video-04&orientation=landscape",
  },
  {
    id: "v5",
    title: "海岸线公路的追光之旅",
    category: "旅行记录",
    duration: "18:12",
    views: "10.9 万",
    desc: "沿东海岸公路自驾三日，记录日出、渔港与临海小镇的沿途见闻。",
    cover:
      "https://readdy.ai/api/search-image?query=coastal%20highway%20road%20trip%20at%20golden%20hour%20with%20ocean%20on%20one%20side%2C%20warm%20sunlight%20and%20soft%20haze%2C%20travel%20documentary%20photography%2C%20wide%20cinematic%20frame&width=800&height=600&seq=sh-video-05&orientation=landscape",
  },
  {
    id: "v6",
    title: "陶艺工坊的慢镜头",
    category: "生活美学",
    duration: "07:55",
    views: "5.2 万",
    desc: "用慢镜头呈现陶土在转盘上成形的过程，配以匠人手作讲述。",
    cover:
      "https://readdy.ai/api/search-image?query=slow%20motion%20of%20hands%20shaping%20clay%20on%20a%20pottery%20wheel%20in%20a%20warm%20studio%2C%20soft%20directional%20light%2C%20terracotta%20and%20cream%20tones%2C%20artisan%20craft%20photography%2C%20high%20detail&width=800&height=600&seq=sh-video-06&orientation=landscape",
  },
  {
    id: "v7",
    title: "雪山徒步的第一缕阳光",
    category: "自然风光",
    duration: "13:27",
    views: "9.6 万",
    desc: "海拔四千米的清晨，记录徒步队伍迎接日照金山的全过程。",
    cover:
      "https://readdy.ai/api/search-image?query=snow%20mountain%20trekking%20at%20sunrise%20with%20hikers%20silhouetted%20against%20glowing%20peaks%2C%20warm%20pink%20and%20amber%20light%2C%20epic%20landscape%20photography%2C%20high%20detail&width=800&height=600&seq=sh-video-07&orientation=landscape",
  },
  {
    id: "v8",
    title: "深夜食堂的菜单故事",
    category: "人文纪实",
    duration: "16:40",
    views: "7.8 万",
    desc: "一家开了二十年的深夜小店，老板讲述菜单背后的四季变化。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20late%20night%20small%20eatery%20with%20warm%20lantern%20light%20and%20steaming%20dishes%2C%20intimate%20documentary%20photography%2C%20amber%20and%20deep%20brown%20tones%2C%20rich%20texture&width=800&height=600&seq=sh-video-08&orientation=landscape",
  },
];

export const videoCategories = [
  "全部",
  "自然风光",
  "人文纪实",
  "城市影像",
  "旅行记录",
  "生活美学",
];

export const photobooks = [
  {
    id: "p1",
    title: "初夏海岸人像写真集",
    model: "摄影师 林深",
    count: 42,
    place: "东海岸礁石滩",
    desc: "以海风与逆光为线索，拍摄清晨到傍晚的完整光影变化。",
    cover:
      "https://readdy.ai/api/search-image?query=tasteful%20seaside%20portrait%20of%20a%20woman%20in%20flowing%20light%20dress%20against%20soft%20morning%20waves%2C%20warm%20beige%20and%20terracotta%20palette%2C%20elegant%20editorial%20photography%2C%20soft%20natural%20light&width=600&height=800&seq=sh-photo-book-01&orientation=portrait",
  },
  {
    id: "p2",
    title: "老洋房里的复古肖像",
    model: "摄影师 苏晚",
    count: 36,
    place: "旧城洋房",
    desc: "借助百叶窗光影与木质家具，还原胶片时代的室内肖像质感。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20indoor%20portrait%20in%20an%20old%20mansion%20with%20window%20blind%20shadows%2C%20warm%20sepia%20and%20cream%20tones%2C%20classic%20film%20photography%20style%2C%20elegant%20mood&width=600&height=800&seq=sh-photo-book-02&orientation=portrait",
  },
  {
    id: "p3",
    title: "山野露营自然写真",
    model: "摄影师 周野",
    count: 28,
    place: "高原草甸",
    desc: "以帐篷与篝火为背景，记录夜晚与清晨两组不同色调的画面。",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20camping%20lifestyle%20portrait%20with%20tent%20and%20warm%20campfire%20glow%20in%20a%20mountain%20meadow%2C%20amber%20and%20olive%20tones%2C%20tasteful%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=sh-photo-book-03&orientation=portrait",
  },
  {
    id: "p4",
    title: "城市天台黄昏合集",
    model: "摄影师 何川",
    count: 31,
    place: "中心商圈天台",
    desc: "在高楼天台等待黄金一小时，拍摄逆光剪影与远景天际线。",
    cover:
      "https://readdy.ai/api/search-image?query=rooftop%20portrait%20at%20golden%20hour%20with%20city%20skyline%20behind%2C%20warm%20amber%20backlight%20and%20soft%20haze%2C%20tasteful%20editorial%20photography%2C%20cinematic%20composition&width=600&height=800&seq=sh-photo-book-04&orientation=portrait",
  },
  {
    id: "p5",
    title: "传统服饰文化写真",
    model: "摄影师 沈墨",
    count: 48,
    place: "园林与水榭",
    desc: "以园林廊桥为场景，呈现传统服饰的面料纹样与行走姿态。",
    cover:
      "https://readdy.ai/api/search-image?query=tasteful%20portrait%20of%20a%20woman%20in%20traditional%20patterned%20dress%20in%20a%20classical%20garden%20corridor%2C%20soft%20filtered%20light%2C%20warm%20cream%20and%20deep%20red%20tones%2C%20cultural%20editorial%20photography&width=600&height=800&seq=sh-photo-book-05&orientation=portrait",
  },
  {
    id: "p6",
    title: "雪国冬日静谧写真",
    model: "摄影师 白桦",
    count: 24,
    place: "北方林场",
    desc: "雪后林场的低温拍摄，以白色雪原衬托人物与暖色衣物的对比。",
    cover:
      "https://readdy.ai/api/search-image?query=tasteful%20winter%20portrait%20in%20a%20snowy%20forest%20with%20warm%20wool%20coat%2C%20soft%20overcast%20light%2C%20cream%20and%20warm%20rust%20accents%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=sh-photo-book-06&orientation=portrait",
  },
];

export const galleryImages = [
  {
    id: "g1",
    title: "晨雾湖面倒影",
    tag: "自然风光",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20lake%20surface%20with%20morning%20mist%20and%20mountain%20reflection%2C%20warm%20golden%20light%2C%20minimal%20nature%20photography%2C%20serene%20atmosphere%2C%20high%20detail&width=600&height=600&seq=sh-gallery-01&orientation=squarish",
  },
  {
    id: "g2",
    title: "巷口早餐摊",
    tag: "人文纪实",
    cover:
      "https://readdy.ai/api/search-image?query=street%20food%20stall%20in%20an%20old%20alley%20with%20steam%20and%20warm%20lantern%20light%2C%20documentary%20photography%2C%20amber%20and%20brown%20tones%2C%20rich%20texture&width=600&height=600&seq=sh-gallery-02&orientation=squarish",
  },
  {
    id: "g3",
    title: "黄昏城市天际线",
    tag: "城市影像",
    cover:
      "https://readdy.ai/api/search-image?query=city%20skyline%20at%20sunset%20with%20warm%20orange%20sky%20and%20silhouetted%20buildings%2C%20cinematic%20urban%20photography%2C%20soft%20haze%2C%20high%20detail&width=600&height=600&seq=sh-gallery-03&orientation=squarish",
  },
  {
    id: "g4",
    title: "雪原松林小径",
    tag: "自然风光",
    cover:
      "https://readdy.ai/api/search-image?query=snowy%20forest%20path%20with%20tall%20pine%20trees%20and%20soft%20winter%20light%2C%20muted%20cream%20and%20cool%20shadow%20tones%2C%20minimal%20landscape%20photography&width=600&height=600&seq=sh-gallery-04&orientation=squarish",
  },
  {
    id: "g5",
    title: "陶土成形的瞬间",
    tag: "生活美学",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20clay%20on%20a%20pottery%20wheel%20being%20shaped%20by%20hands%2C%20warm%20studio%20light%2C%20terracotta%20and%20cream%20tones%2C%20craft%20photography%2C%20high%20detail&width=600&height=600&seq=sh-gallery-05&orientation=squarish",
  },
  {
    id: "g6",
    title: "临海小镇渔港",
    tag: "旅行记录",
    cover:
      "https://readdy.ai/api/search-image?query=small%20coastal%20fishing%20harbor%20with%20wooden%20boats%20at%20golden%20hour%2C%20warm%20amber%20light%20and%20calm%20sea%2C%20travel%20documentary%20photography%2C%20high%20detail&width=600&height=600&seq=sh-gallery-06&orientation=squarish",
  },
  {
    id: "g7",
    title: "雨夜坡道灯火",
    tag: "城市影像",
    cover:
      "https://readdy.ai/api/search-image?query=rainy%20night%20sloped%20street%20with%20warm%20reflected%20lamps%20on%20wet%20pavement%2C%20cinematic%20mood%2C%20amber%20and%20deep%20brown%20tones%2C%20atmospheric%20photography&width=600&height=600&seq=sh-gallery-07&orientation=squarish",
  },
  {
    id: "g8",
    title: "高原草甸晚霞",
    tag: "自然风光",
    cover:
      "https://readdy.ai/api/search-image?query=highland%20meadow%20under%20a%20dramatic%20sunset%20sky%2C%20warm%20pink%20and%20amber%20clouds%2C%20wide%20open%20nature%20photography%2C%20serene%20and%20expansive%2C%20high%20detail&width=600&height=600&seq=sh-gallery-08&orientation=squarish",
  },
  {
    id: "g9",
    title: "旧书摊的午后",
    tag: "人文纪实",
    cover:
      "https://readdy.ai/api/search-image?query=second%20hand%20book%20stall%20on%20a%20sunny%20afternoon%20with%20warm%20light%20on%20worn%20pages%2C%20nostalgic%20documentary%20photography%2C%20cream%20and%20brown%20tones%2C%20rich%20texture&width=600&height=600&seq=sh-gallery-09&orientation=squarish",
  },
  {
    id: "g10",
    title: "手冲咖啡的光影",
    tag: "生活美学",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20hand%20pouring%20coffee%20with%20warm%20window%20light%20and%20steam%2C%20cream%20and%20amber%20tones%2C%20minimal%20lifestyle%20photography%2C%20high%20detail&width=600&height=600&seq=sh-gallery-10&orientation=squarish",
  },
  {
    id: "g11",
    title: "山间云海日出",
    tag: "自然风光",
    cover:
      "https://readdy.ai/api/search-image?query=sea%20of%20clouds%20above%20mountain%20peaks%20at%20sunrise%2C%20warm%20golden%20light%20on%20misty%20ridges%2C%20epic%20landscape%20photography%2C%20high%20detail&width=600&height=600&seq=sh-gallery-11&orientation=squarish",
  },
  {
    id: "g12",
    title: "古镇石板长街",
    tag: "旅行记录",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20town%20stone%20paved%20street%20at%20dusk%20with%20warm%20hanging%20lanterns%2C%20travel%20documentary%20photography%2C%20amber%20and%20terracotta%20tones%2C%20atmospheric%20depth&width=600&height=600&seq=sh-gallery-12&orientation=squarish",
  },
];

export const galleryTags = [
  "全部",
  "自然风光",
  "人文纪实",
  "城市影像",
  "旅行记录",
  "生活美学",
];

export const categories = [
  {
    name: "自然风光",
    desc: "山川湖海、星空雪原的纪实影像与延时视频",
    count: 186,
    icon: "ri-landscape-line",
  },
  {
    name: "人文纪实",
    desc: "市井日常、手工艺与老城记忆的观察记录",
    count: 142,
    icon: "ri-camera-line",
  },
  {
    name: "城市影像",
    desc: "街头光影、建筑线条与夜间城市节奏",
    count: 121,
    icon: "ri-building-2-line",
  },
  {
    name: "旅行记录",
    desc: "公路、海岸与小镇的完整旅途见闻",
    count: 98,
    icon: "ri-road-map-line",
  },
  {
    name: "生活美学",
    desc: "咖啡、器物与日常仪式感的慢镜头",
    count: 87,
    icon: "ri-cup-line",
  },
  {
    name: "写真合集",
    desc: "按场景与色调整理的成套人物写真",
    count: 64,
    icon: "ri-user-3-line",
  },
];

export const updateList = [
  {
    title: "戈壁星空下的银河延时",
    type: "视频",
    date: "2026-10-09",
    note: "新增 4K 版本与拍摄参数说明",
  },
  {
    title: "初夏海岸人像写真集",
    type: "写真",
    date: "2026-10-08",
    note: "更新 12 张傍晚逆光选片",
  },
  {
    title: "复古胶片色彩图集",
    type: "图片",
    date: "2026-10-07",
    note: "补充 30 张街拍与生活静物",
  },
  {
    title: "海岸线公路的追光之旅",
    type: "视频",
    date: "2026-10-06",
    note: "新增第二集渔港段落",
  },
  {
    title: "传统服饰文化写真集",
    type: "写真",
    date: "2026-10-05",
    note: "整理园林水榭场景全部成片",
  },
  {
    title: "雪原松林与小径",
    type: "图片",
    date: "2026-10-04",
    note: "新增冬季专题 18 张",
  },
  {
    title: "陶艺工坊的慢镜头",
    type: "视频",
    date: "2026-10-03",
    note: "补充匠人访谈字幕",
  },
];

export const updateFilters = ["全部", "视频", "写真", "图片"];

export const guideSteps = [
  {
    title: "按分区浏览",
    desc: "页面上方按视频、写真、图片三类整理，可从任意分区直接进入对应内容列表。",
  },
  {
    title: "用标签快速筛选",
    desc: "在视频区与图片区点击主题标签，列表会即时过滤出本页已有的相关条目。",
  },
  {
    title: "查看条目详情说明",
    desc: "每个条目都标注了时长或张数、拍摄场景与内容说明，方便判断是否符合浏览需求。",
  },
  {
    title: "收藏与整理",
    desc: "对感兴趣的资源可记录名称与编号，在「最新收录」中按更新时间回看全部更新。",
  },
];

export const faqs = [
  {
    q: "这个站点主要提供哪些类型的资源？",
    a: "站点集中整理三类内容：视频资源（自然风光、人文纪实、城市影像等纪实短片）、写真合集（按场景与色调整理的成套人物写真）以及图片资源（单张摄影作品与专题图集）。所有条目都带有分类、时长或张数与内容说明。",
  },
  {
    q: "资源是如何分类和整理的？",
    a: "目前按自然风光、人文纪实、城市影像、旅行记录、生活美学与写真合集六个方向组织。视频区与图片区都提供主题标签，点击即可在本页范围内筛选，不需要跳转到其他页面。",
  },
  {
    q: "如何判断某个条目是否符合浏览需求？",
    a: "每个条目卡片都会展示标题、分类、时长或张数以及一段内容说明，视频条目还会标注画质信息。可以先通过标签缩小范围，再阅读说明，避免逐个打开。",
  },
  {
    q: "内容多久更新一次？",
    a: "页面中的「最新收录」分区按更新时间列出近期新增与修订的条目，包含更新日期与变更说明，方便按时间顺序了解最近的整理情况。",
  },
  {
    q: "在手机上浏览体验如何？",
    a: "页面采用响应式布局，卡片在手机端会自动调整为单列或双列，标签与筛选控件支持点按和键盘操作，文字与按钮尺寸针对小屏做了适配，保证密集内容也能顺畅阅读。",
  },
];